import website from "@/client/api/website";

export default {
    state: {
        // isLoggedIn: false,
        // showLoginModal: true,
        currentWebsiteId: null,
        websites: [],
    },
    getters: {},
    mutations: {
        setCurrentWebsite(state, site_id) {
            state.currentWebsiteId = site_id;
        },
        setWebsites(state, value) {
            state.websites = value;
        },
        // showingLoginModal(state, show) {
        //     state.showLoginModal = show;
        // },
        // changeLoggedIn(state, logged_in) {
        //     state.isLoggedIn = logged_in;
        // },
    },
    actions: {
        async queryWebsites({ commit }) {
            let res = await website.getWebsites();
            if (res.data && res.data.data) {
                commit("setWebsites", res.data.data);
            }
        },
    },
};
